// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74d075e4","239":"a6d5727a","453":"237c40a8","732":"97aefb7c"}[chunkId] + ".chunk.js";
};